/**
 * @voltxampere/ui — 74HC4051 8-channel analog mux CMOS variant (Sprint 43-6)
 *
 * Sprint 43 ADR-0063 introduced the `analog-mux-8` canonical engine
 * type. 74HC4051 is the high-speed CMOS counterpart of the 4051 with
 * tighter Vcc range (2-10 V) and faster propagation. Same select +
 * enable semantics.
 *
 * Reference: NXP 74HC4051. 8 analog input channels, 3 binary select
 * pins, active-LOW E. Vcc 2-10 V, propagation typ 24 ns at Vcc=5 V.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const logic74hc4051 = {
    id: "74hc4051",
    nameTr: "74HC4051 (8 Kanal Analog Mux CMOS Hızlı, DIP-16)",
    nameEn: "74HC4051 (8-Channel High-Speed CMOS Mux, DIP-16)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "74HC4051",
    schemaType: "analog-mux-8",
    defaultParams: {
        channelCount: 8,
        threshold: 2.5,
        enableActiveLow: true,
        rOn: 70,
        propagationDelay: 24e-9,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=logic-74hc4051.js.map